// extracted by css-extract-rspack-plugin
export default {"headerTwo":"ConfirmationCodeStep_headerTwo__JB9OW"};